import Vue from 'vue'
import Vuex from 'vuex'
import { stat } from 'fs';

Vue.use(Vuex)

//apiUrl: 'http://211.33.36.42:20036/api/',
export default new Vuex.Store({
    state: {
        apiUrl: 'http://192.168.120.220:8000/api/',
        transition: 'content-slide',
        reportLogin: {
            email: localStorage.getItem('posco.yoonri.email'),
            password: localStorage.getItem('posco.yoonri.password')
        },
        deviceReady: false,
        addrApiKey: 'U01TX0FVVEgyMDE3MDYwMzA0NTI1MzIxNjM2', // 문제가 생길경우 키 변경 필요 (http://www.juso.go.kr)
    },
    mutations: {
        setTransition(state, flag) {
            state.transition = flag
        },
        setReportLogin(state) {
            state.reportLogin.email = localStorage.getItem('posco.yoonri.email')
            state.reportLogin.password = localStorage.getItem('posco.yoonri.password')
        },
        setReportLogout(state) {
            state.reportLogin.email = ''
            state.reportLogin.password = ''

            localStorage.removeItem('posco.yoonri.email')
            localStorage.removeItem('posco.yoonri.password')
        },
        setDeviceReady(state, flag) {
            state.deviceReady = flag
        },
        setApiURL(state, url) {
            state.apiUrl = url
        }
    },
    getters: {
        getReportLoginState(state) {
            if (state.reportLogin.email !== null || state.reportLogin.password !== null) {
                return true
            }

            return false
        },
        getReportEmail(state) {
            return state.reportLogin.email
        },
        getReportPwd(state) {
            return state.reportLogin.password
        },
        getDeviceReady(state) {
            return state.deviceReady
        }
    },
    actions: {

    }
})



// WEBPACK FOOTER //
// ./src/store.js